import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Profile } from "../types";
import {
  fetchProfile,
  editProfileThunk,
  submitUserRegistrationDetailsThunk,
} from "./thunk/profileThunk";
import { toast } from "react-toastify";

export interface ProfileState {
  // <-- export this
  profile: Profile | null;
  loading: boolean;
  error: string | null;
  isUserProfileOpen: boolean;
}

const initialState: ProfileState = {
  profile: null,
  loading: false,
  error: null,
  isUserProfileOpen: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    toggleUserProfile(state, action: PayloadAction<boolean>) {
      state.isUserProfileOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchProfile
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchProfile.fulfilled,
        (state, action: PayloadAction<Profile>) => {
          state.loading = false;
          state.profile = action.payload;
        },
      )
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.profile = null;
        state.error = action.payload as string;
      })
      // editProfileThunk
      .addCase(editProfileThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        editProfileThunk.fulfilled,
        (state, action: PayloadAction<Profile>) => {
          state.loading = false;
          state.profile = action.payload;
          toast.success("Updated");
        },
      )
      .addCase(editProfileThunk.rejected, (state, action) => {
        state.loading = false;
        state.profile = null;
        state.error = action.payload as string;
        toast.error(action.payload as string);
      })
      // update profile in redux

      .addCase(submitUserRegistrationDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        submitUserRegistrationDetailsThunk.fulfilled,
        (state, action: PayloadAction<Profile>) => { 
          state.loading = false;
          if (!state.profile) return;

          if (state.profile.organizations?.length > 0) {
            state.profile.organizations[0] = {
              ...state.profile.organizations[0],
              ...action.payload,
            };
          }

          if (action.payload.user_category !== undefined) {
            state.profile.user_category = action.payload.user_category;
          }
        },
      );
  },
});

export const { toggleUserProfile } = profileSlice.actions;
export default profileSlice.reducer;
